import { useContext, useMemo } from 'react';

import { TicketContext } from '../../contexts/TicketContext';
import ContentfulService, { DateRange } from '../ContentfulService';

interface UseFormattingOptions {
  range?: DateRange;
  replaceDate?: string | null;
  roundTo?: number;
}

export const useFormatting = (text: string | undefined, options: UseFormattingOptions = {}): { formattedText: string } => {
  const { ticket } = useContext(TicketContext);
  const { replaceDate, range, roundTo } = options;

  const formattedText = useMemo((): string => {
    let val = text || '';

    if (!text) {
      return '';
    }

    val = ContentfulService.convertHtmlTag(val);

    if (ticket) {
      val = ContentfulService.convertTicketTag(val, ticket.hashId);
    }

    if (replaceDate) {
      val = ContentfulService.convertDateTag(val, replaceDate, {
        range,
        roundDurationTo: roundTo
      });
    }

    return val;
  }, [text, ticket, replaceDate, range, roundTo]);

  return { formattedText };
};
